import { WarehouseType } from '../types';

export const WAREHOUSE_DISPLAY_NAMES: Record<WarehouseType, string> = {
  snowflake: 'Snowflake',
  redshift: 'Redshift',
  bigquery: 'BigQuery',
  databricks: 'Databricks',
  postgres: 'Postgres',
  athena: 'Athena',
  clickhouse: 'ClickHouse',
  dremio: 'Dremio',
  fabric: 'Fabric',
};
